import { JustificativaModal } from '@components/Modal/JustificativaModal';
import { IForm } from '@hooks/useForm';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IJustificativaRequest } from '@hooks/useRequest';
import { IContratoCliente } from '@model/ContratoCliente';
import { useContratoClienteService } from '@services/ContratoClienteService';
import { AxiosResponse } from 'axios';
import React from 'react';

export type ContratoClienteReativarModalProps = {
    contratoCliente: IContratoCliente
    modal: IModalWindow
    onContratoReativado: (response: AxiosResponse<IContratoCliente>) => void
}

export function ContratoClienteReativarModal ({ contratoCliente, modal, onContratoReativado }: ContratoClienteReativarModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const contratoClienteService = useContratoClienteService();

    const handleConfirm = React.useCallback((values: IJustificativaRequest, form: IForm<IJustificativaRequest>) => {
        if (!loading.isLoading) {
            loading.start();
            contratoClienteService.reativar(contratoCliente.contratoClienteId, values)
                .then(response => {
                    message.success("Contrato reativado com sucesso");
                    modal.close();
                    onContratoReativado(response);
                })
                .catch(e => {
                    message.handleResponse(e)
                        .badRequest(form.setErrorsFromServer)
                        .showException();
                })
                .finally(loading.stop)
        }
    }, [contratoCliente.contratoClienteId, contratoClienteService, loading, message, modal, onContratoReativado]);

    return (
        <JustificativaModal 
            confirmText="Reativar Contrato"
            disabled={loading.isLoading}
            modal={modal}
            onConfirm={handleConfirm}
            title={`Reativação do contrato ${contratoCliente.contratoClienteId}`}
        />
    )
}